import { render, staticRenderFns } from "./addThreeSDK.vue?vue&type=template&id=a0bd29b2&scoped=true&"
import script from "./addThreeSDK.vue?vue&type=script&lang=js&"
export * from "./addThreeSDK.vue?vue&type=script&lang=js&"
import style0 from "./addThreeSDK.vue?vue&type=style&index=0&id=a0bd29b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bd29b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0bd29b2')) {
      api.createRecord('a0bd29b2', component.options)
    } else {
      api.reload('a0bd29b2', component.options)
    }
    module.hot.accept("./addThreeSDK.vue?vue&type=template&id=a0bd29b2&scoped=true&", function () {
      api.rerender('a0bd29b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/addThreeSDK.vue"
export default component.exports